import { createFetchResponseError, handleFetchError } from './fetch-error-handling';

export class BackendLogger {
    private apiUrl: string;

    constructor(apiUrl: string) {
        this.apiUrl = apiUrl;
    }

    public async postError(error: string): Promise<void> {
        const requestUrl = `${this.apiUrl}log-error`;
        const bodyFormData = new FormData();
        bodyFormData.append('error', error);

        try {
            const response = await fetch(requestUrl, {
                method: 'POST',
                body: bodyFormData,
            });

            if (!response.ok) {
                handleFetchError(await createFetchResponseError(response), false, this.apiUrl);
            }
        } catch (fetchError) {
            handleFetchError(
                fetchError instanceof Error ? fetchError : new Error(String(fetchError)),
                false,
                this.apiUrl
            );
        }
    }
}
